import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import ServicesEditorial from "@/components/home/ServicesEditorial";
import DataJourney from "@/components/home/DataJourney";
import FinalCTA from "@/components/home/FinalCTA";
import { PrimaryCTA, SecondaryCTA } from "@/components/CTAButton";

export default function Solutions() {
  return (
    <>
      <SEO
        title="Solutions | All Data Tech"
        description="Explore All Data Tech solutions: AI & Machine Learning, Data Engineering, Analytics & BI, Predictive Analytics, Cloud Data and Data Automation."
        path="/solutions"
      />
      <PageHero
        eyebrow="Solutions"
        title={<>Technology built around <span className="text-gradient">your business.</span></>}
        sub="Six connected capabilities that move you from raw data to intelligent, automated decisions."
      >
        <div className="flex flex-col gap-3 sm:flex-row">
          <PrimaryCTA to="/consultation" testId="solutions-hero-cta">Book a Consultation</PrimaryCTA>
          <SecondaryCTA to="/services" testId="solutions-hero-services">View Services</SecondaryCTA>
        </div>
      </PageHero>
      <ServicesEditorial heading={false} />
      <DataJourney />
      <FinalCTA />
    </>
  );
}
